import React from "react";
import SectionShell from "./SectionShell";

export default function LifeSpeaksSection() {
  return (
    <SectionShell
      id="elet-beszel"
      testId="life-speaks-section"
      eyebrow="Csendes üzenetek"
      titleStart="Az élet folyamatosan"
      titleAccent="beszél hozzánk"
      tinted
    >
      <p>
        Az élet folyamatosan beszél hozzánk. Kérdés, hogy meghalljuk-e. Néha egy kapcsolaton,
        egy konfliktuson vagy egy visszatérő helyzeten keresztül. Máskor egy veszteség,
        fájdalom vagy „kellemetlen" érzelem formájában. Az élet nem ellenünk dolgozik. Még
        akkor sem, amikor ezt érezzük. Sokkal gyakrabban próbál megmutatni valamit, amit még
        nem látunk teljesen. Ami újra és újra megjelenik az életünkben, gyakran nem véletlenül
        érkezik. Lehet, hogy valamit szeretne megmutatni, ami által közelebb kerülünk ahhoz,
        akik valójában lehetnénk. Hiszen ami tudatossá válik, az már nem ugyanúgy hat ránk,
        mint korábban. Ami pedig láthatóvá válik, az lehetőséget ad arra, hogy másképp
        kapcsolódjunk hozzá. Ezeket a területeket térképezzük fel közösen, és világítjuk meg
        egy magasabb nézőpontból.
      </p>
    </SectionShell>
  );
}
